<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col >
		<!-- <b-row class="breadcrumbrow mt-1 m-0">
				
				<b-col>
				
				 <h5 class="text-center">Sales Advisor Dashboard</h5>
				
				
				
				</b-col>
				
				</b-row>-->
			<!--<b-row class="breadcrumbrow"><b-col>			
			<a v-if="!statusSidebar" href="javascript:void(0)" id="menu-toggle" @click="burgerMenuSidebar" v-b-toggle="'sidebar-fifi-toggle'">	<i class="fa fa-arrow-left" style="font-size:24px"></i> Close Menu</a>
			<a v-else href="javascript:void(0)"  id="menu-toggle" @click="burgerMenuSidebar" v-b-toggle="'sidebar-fifi-toggle'"><i class="fa fa-bars" aria-hidden="true" style="font-size:24px"></i></a>
			</b-col></b-row> -->
			
		<b-container fluid class="p-0 mt-2" >
		
		<b-tabs content-class="mt-3" fill pills  class="profileTab">
			<b-tab title="Account Details" active>
				<!-- <profile-account :profile="profile"></profile-account>-->
				<profile-account></profile-account>
			
			</b-tab>

			<!--<b-tab title="Business Details" >
				<profile-business></profile-business>
			</b-tab> -->
			<b-tab title="Payment Details">
			<profile-bank></profile-bank>
			
			
			</b-tab>
			
		  </b-tabs>
		
		
		</b-container>
		
		
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
		
	</div>
	
</template>
<script>
import '@/assets/profileuser.scss';
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/agent/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
import ProfileBank from "@/components/profile-bank.vue";
import ProfileAccount from "@/components/profile-account.vue";
//import ProfileBusiness from "@/components/profile-business.vue";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"profile-bank": ProfileBank,
		"profile-account": ProfileAccount,
		/*"profile-business": ProfileBusiness, */
	},
	mounted(){
		//var self = this;
       // Object.assign(self.selectedItem, self.emptyItem);
        
		//this.initProfile();
	},
	data() {
            return{
            loading: false, 
            addOfficeaddress:0,			
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_csv: null,
			statusSidebar: false,
            model_maps: {},		
            profile: {
                details: {
                    address:null,
                    category: null,
                    city:null,
                    dob:null,
                    gender: null,
                    payment_detail:{
                        beneficiary:null,
                        account:null,
                        bank:null,
                        ifsc:null
                    },
                    pincode:null,
                    social:{
                        facebook:null,
                        instagram:null,
                        tweeter:null,
                        whatsapp:null
                    },
                    state:null,
                    shipping:{
                        address:null,
                        city:null,
                        state:null,
                        pincode:null
                    },
                },
                
                email:'',
                phone:'',
                username:'',
                firstname:'',
                lastname:'',
                image:'',
                address:'',
                location:'',
                city:'',
                state:'',
                pincode:'',
                country:'',
                social:'',
				
            },
            recordUrl: this.$root.NEWAPIURL+'sellerapi/load-profile',
            updateUrl: this.$root.NEWAPIURL+'sellerapi/update-profile',
            categories: [
                { text: 'Fashion', value: 'fashion' },
                { text: 'Cosmetics', value: 'cosmetics' },
                { text: 'Vouchers', value: 'vouchers' },
                { text: 'Organic', value: 'organic' },
                { text: 'Home Essentials', value: 'home-essentials' }
            ],
            categoryOptions: [],
            breadcrumb: [
                    {
                        text: 'Home',
                        href: '/'
                    },
                    {
                        text: 'Products',
                        active: true
                    }
            ],
            /*fields: [
                { key: 'id', label: 'ID'},
                { key: 'records', label: 'Records'},
                { key: 'insert_time', label: 'Insert Time'},
                { key: 'status', label: 'Status' },
                { key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
            ],*/
            itemfields:[
                { key: 'product_id', label: 'PID'},
                { key: 'sku', label: 'SKU'},
                { key: 'total_images', label: 'TOTAL IMAGES'},
				{ key: 'status', label: 'Status' },
            ],
            totalRows: 1,
            currentPage: 1,
            pageOptions: [10, 20, 50, 100],
            perPage: 10,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            selectedItem: {product_data:{}, tier_price:[]},
            
            counterindex:1
	};
    },
	methods: {
		
	}
}
</script>
<!-- scoped  -->
<style scoped lang="scss">

</style>